Array.remove = (arr, obj) => {
    for (let i = 0; i < arr.length; i++) {
        if (arr[i] === obj) {
            arr.splice(i, 1);
            i = i - 1;
        }
    }
    return arr;
};
